import { Component, OnInit } from '@angular/core';
import { seoservice } from './../common/services/seo.service';

@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.css']
})
export class AboutusComponent implements OnInit {

  constructor(private SeoService: seoservice) { }

  ngOnInit() {
    this.SeoService.setPageMetaData('About Us | The most rewarding business community - Conversant.pro','Connect with peers, business opportunities and industry news while earning rewards for participation in the community and business surveys.');
  }

}
